export const tid = (name: string, prefix?: string) => {
    const testId = name.replace(/[^a-z0-9]/gi, '_')
    return (!prefix ? testId : prefix + '_' + testId).toLowerCase()
}
